// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import {store} from './store/store'

import {firestorePlugin} from 'vuefire'
import firebase from 'firebase/app'
import 'firebase/firestore'
import VueSwal from 'vue-swal'
import Moment from 'moment'
import momentSL from 'moment/locale/sl.js'
import momentDurationFormatSetup from 'moment-duration-format'
import 'bootstrap/dist/css/bootstrap.css'
import './assets/css/main.css'
import BootstrapVue from 'bootstrap-vue'
import _ from 'lodash'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import * as VueGoogleMaps from 'vue2-google-maps'
import VeeValidate from 'vee-validate';
import JsonExcel from 'vue-json-to-excel'
import VueExcelXlsx from "vue-excel-xlsx";

Vue.use(firestorePlugin)
Vue.use(BootstrapVue)
Vue.use(VueSwal)
Vue.use(VeeValidate, {fieldsBagName: 'formFields'});
Vue.component('downloadExcel', JsonExcel);
Vue.use(VueExcelXlsx);

firebase.initializeApp({
  apiKey: "AIzaSyCJcDP6TxCFEwdyLCaFeG94SXifKV-tOc0",
  authDomain: "hram-2b241.firebaseapp.com",
  databaseURL: "https://hram-2b241.firebaseio.com",
  projectId: "hram-2b241",
  storageBucket: "hram-2b241.appspot.com",
  messagingSenderId: "417250320022",
  appId: "1:417250320022:web:98996fe50789d8b989ecb7"
})

export const db = firebase.firestore()

Vue.config.productionTip = false

momentDurationFormatSetup(Moment);
Vue.prototype.moment = Moment;
Vue.prototype.moment.locale('sl', momentSL);

export const moment = Vue.prototype.moment;

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDS9ON0NEo3xcbYY3Db4J_eoA8mV7_rc-o',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then disable the following:
  // installComponents: true,
})

Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js